import React, { useState, useEffect } from 'react'
import { Button } from 'primereact/button';
import Select from 'react-select';
import { SplitButton } from 'primereact/splitbutton';
import '../../quoter/styleQuoters/styleFooterClinics.css'
import '../../quoter/styleQuoterClinicMovil/styleFooterClinicsMobile.css'

export const IndexFooterQuoterClinics = (props) => {
    const {
        //? DISCOUNT
        id_preloaded_discount, listPreloaded, removePreloadedDiscount, CustomClearIndicator,
        loadingDiscount, handleApplyDiscount, 

        //? BREAKDOWN
        number_format, subTotalW, totalDiscountW, totalTaxesW, totalW,

        //? ACTIONS 
        loadingCreate, loadingSend, sentPdf, loadingDownloadId, downdloadQuoter, 
        goToListQuoter, newQuotationItems, saveCreate, 
        
        //? DATA
        listQuoterTest, handleSelectValues, chekTypeClient, 

        //? OTHERS
        activeView, viewQuoter,
    } = props
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const [showFooterSheet, setShowFooterSheet] = useState(false);

    return (
        <>
            {
                //* FOOTER 
            }
            {  
                !isMobile && ( activeView !== 0 && (

                    <footer className={`quoter-footer ${viewQuoter ? "quoter-footer-success" : ""}`}>     
                        {
                            !viewQuoter && (
                                <>
                                    { chekTypeClient === 1 && (

                                        <div className="footer-discount-inline">

                                            <Select
                                                isDisabled={listQuoterTest.length === 0}
                                                classNamePrefix="footer-select"
                                                name="id_preloaded_discount"
                                                value={id_preloaded_discount}
                                                options={listPreloaded}
                                                placeholder="Descuento"
                                                isClearable={true}
                                                menuPlacement="top"
                                                menuPortalTarget={document.body}
                                                onChange={(e, actionMeta) => {
                                                if (actionMeta.action === "clear") {

                                                        removePreloadedDiscount();

                                                    } else {

                                                        handleSelectValues(
                                                            e,
                                                            "id_preloaded_discount"
                                                        );

                                                    }

                                                }}

                                                styles={{

                                                    control: (base) => ({
                                                        ...base,
                                                        minHeight: 36,
                                                        height: 36,
                                                        borderRadius: 10,
                                                        borderColor: "#d9e2ef",
                                                        fontSize: 12,
                                                        boxShadow: "none"
                                                    }),

                                                    valueContainer: (base) => ({
                                                        ...base,
                                                        height: 36,
                                                        padding: "0 10px"
                                                    }),

                                                    input: (base) => ({
                                                        ...base,
                                                        margin: 0,
                                                        padding: 0
                                                    }),

                                                    indicatorsContainer: (base) => ({
                                                        ...base,
                                                        height: 36
                                                    }),

                                                    container:(base)=>({
                                                            ...base,
                                                            width:"250px",
                                                            minWidth:"250px"
                                                    }),

                                                    menuPortal: base => ({
                                                        ...base,
                                                        zIndex: 9999
                                                    })
                                                }}

                                                components={{
                                                    ClearIndicator: CustomClearIndicator
                                                }}

                                            />

                                            <Button disabled={ listQuoterTest.length === 0 || loadingDiscount } onClick={handleApplyDiscount} className={`btn-footer-discount ${ loadingDiscount ? "loading" : "" }`} >
                                                {
                                                    loadingDiscount ? (
                                                        <>
                                                            <i className="fa fa-circle-o-notch fa-spin"></i>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fa fa-check-circle"></i>
                                                            <span>Aplicar</span>
                                                        </>
                                                    )
                                                }
                                            </Button>

                                        </div>

                                        )
                                    }

                                    <div className="quoter-footer-left">
                                        {/* <div className="footer-pill">
                                            <span className="label">ESTUDIOS</span>
                                            <strong>{listQuoterTest.length}</strong>
                                        </div> */}

                                        <div className="footer-pill">
                                            <span className="label">SUBTOTAL</span>
                                            <strong>$ {number_format(subTotalW, 2)}</strong>
                                        </div>

                                        <div className="footer-pill">
                                            <span className="label">IVA</span>
                                            <strong>$ {number_format(totalTaxesW, 2)}</strong>
                                        </div>
                                        { chekTypeClient === 1 && (
                                            <div className="footer-pill discount">
                                                <span className="label">DESCUENTO</span>
                                                <strong>$ {number_format(totalDiscountW, 2)}</strong>
                                            </div>
                                        )}

                                        <span className="total-label-quoter-clinics">
                                            TOTAL
                                        </span>

                                        <span className="total-amount-quoter-clinics">
                                            $ {number_format(totalW, 2)}
                                        </span>
                                    </div>
                                                                  
                                    {/* <div className="quoter-footer-center">
                                        <span className="total-label-quoter-clinics">
                                            TOTAL
                                        </span>

                                        <span className="total-amount-quoter-clinics">
                                            $ {number_format(totalW, 2)}
                                        </span>

                                    </div> */}
                                </>
                            )
                        }

                        <div className="quoter-footer-right">
                            {
                                loadingCreate ? (

                                    <Button label="Generando..." icon="pi pi-spin pi-spinner" className="btn-loading-quoter" style={{ backgroundColor: "#1976d2", color: "#fff", borderColor: "#1976d2" }} disabled />
                                ) : viewQuoter ? (

                                    <div className="footer-actions-success">
                                        <Button
                                            label={loadingSend ? "Enviando..." : "Enviar PDF"}
                                            icon={loadingSend ? "pi pi-spin pi-spinner" : "pi pi-envelope"}
                                            className="btn-send-quoter"
                                            onClick={() => sentPdf()}
                                            disabled={loadingSend ? true : false}
                                        />

                                        <Button
                                            label={loadingDownloadId === null ? "Descargar PDF" : "Descargando..."}
                                            icon={loadingDownloadId === null ? "pi pi-download" : "pi pi-spin pi-spinner"}
                                            className="btn-download-quoter"
                                            onClick={() => downdloadQuoter()}
                                            disabled={loadingDownloadId !== null ? true : false}
                                        />

                                            <Button
                                            label="Listado de cotización"
                                            icon="pi pi-list"
                                            className="btn-list-quoter"
                                            onClick={goToListQuoter}
                                        />
                            
                                        <SplitButton
                                            label="Cotización"
                                            icon="pi pi-plus"
                                            model={newQuotationItems}
                                            className="btn-new-quoter"
                                        />

                                    </div>

                                ) : (
                                    <>
                                    <div className="footer-study-count">
                                        <span className="badge-count">{listQuoterTest.length}</span>
                                        <span>{listQuoterTest.length === 1 ? "Estudio" : "Estudios"}</span>
                                    </div>

                                    <button
                                        className="btn-footer btn-pay-quoter"
                                        onClick={saveCreate}
                                        disabled={listQuoterTest.length === 0}
                                    >
                                        Generar cotización
                                        <i className="fa fa-chevron-right"></i>
                                    </button>
                                    </>

                                    

                                )
                            }

                        </div>
                    </footer>
                ))
            }

            {
                isMobile && activeView !== 0 && (
                    <footer className={`quoter-footer-mobile ${ showFooterSheet ? "open" : "closed"}`}>
                        <button className="mobile-btn-expand" onClick={() => setShowFooterSheet(!showFooterSheet)}>
                            <i className={`fa ${ showFooterSheet ? "fa-chevron-down" : "fa-sliders" }`} />
                        </button>


                        <div className="mobile-footer-content">
                            
                        {
                            //* DISCOUNT
                        }

                        {
                            chekTypeClient === 1 && !viewQuoter && (
                                <>

                                    <div className="mobile-discount-row">

                                        <div className="mobile-discount-select">
                                            <Select
                                                isDisabled={listQuoterTest.length === 0}
                                                classNamePrefix="footer-select"
                                                name="id_preloaded_discount"
                                                value={id_preloaded_discount}
                                                options={listPreloaded}
                                                placeholder="Selecciona un descuento"
                                                isClearable
                                                menuPlacement="top"
                                                menuPortalTarget={document.body}
                                                onChange={(e, actionMeta) => {

                                                    if (actionMeta.action === "clear") {

                                                        removePreloadedDiscount();

                                                    } else {

                                                        handleSelectValues(
                                                            e,
                                                            "id_preloaded_discount"
                                                        );

                                                    }

                                                }}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        minHeight: 36,
                                                        height: 36,
                                                        borderRadius: 10,
                                                        borderColor: "#d9e2ef",
                                                        boxShadow: "none"
                                                    }),

                                                    valueContainer: (base) => ({
                                                        ...base,
                                                        height: 36,
                                                        padding: "0 10px"
                                                    }),

                                                    input: (base) => ({
                                                        ...base,
                                                        margin: 0,
                                                        padding: 0,
                                                        fontSize: "16px"
                                                    }),

                                                    singleValue: (base) => ({
                                                        ...base,
                                                        fontSize: "12px"   
                                                    }),

                                                    placeholder: (base) => ({
                                                        ...base,
                                                        fontSize: "12px"
                                                    }),

                                                    option: (base) => ({
                                                        ...base,
                                                        fontSize: "12px"
                                                    }),

                                                    indicatorsContainer: (base) => ({
                                                        ...base,
                                                        height: 36
                                                    }),

                                                    container: (base) => ({
                                                        ...base,
                                                        width: "250px",
                                                        minWidth: "250px"
                                                    }),

                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999
                                                    })
                                                }}

                                                components={{
                                                    ClearIndicator: CustomClearIndicator
                                                }}
                                            />
                                        </div>

                                        <Button
                                            disabled={
                                                listQuoterTest.length === 0 ||
                                                loadingDiscount
                                            }
                                            onClick={handleApplyDiscount}
                                            className={`btn-footer-discount ${
                                                loadingDiscount ? "loading" : ""
                                            }`}
                                        >

                                            {
                                                loadingDiscount
                                                    ? <i className="fa fa-circle-o-notch fa-spin" />
                                                    :
                                                    <>
                                                        
                                                        <span>Aplicar</span>
                                                    </>
                                            }

                                        </Button>
                                    </div>

                                </>

                            )
                        }   
                        {
                            !viewQuoter && (
                                <>
                                    <div className="mobile-footer-summary">
                                        <div className="mobile-summary-pill">
                                            <span>SUBTOTAL</span>
                                            <strong>
                                                $ {number_format(subTotalW,2)}
                                            </strong>
                                        </div>

                                        <div className="mobile-summary-pill">
                                            <span>IVA</span>
                                            <strong>
                                                $ {number_format(totalTaxesW,2)}
                                            </strong>
                                        </div>

                                        <div className="mobile-summary-pill">
                                            <span>DESCUENTO</span>
                                            <strong>
                                                $ {number_format(totalDiscountW,2)}
                                            </strong>
                                        </div>
                                    </div>
                                    <br />
                                </>
                            
                            )
                        }
                            
                        {
                            //* TOTAL
                        }

                        {
                            !viewQuoter && (
                                <div className="mobile-total">
                                    <span>TOTAL</span>
                                    <strong>
                                        $ {number_format(totalW,2)}
                                    </strong>
                                </div>
                            )
                        }

                        {
                            //* ACTIONS
                        }

                        {
                            !viewQuoter && (
                                <div className="mobile-footer-actions">
                                    <div className="mobile-studies">
                                        <i className="fa fa-flask"></i>
                                        {listQuoterTest.length}
                                    </div>
                                    {
                                        loadingCreate ?
                                            <Button label="Generando..." icon="pi pi-spin pi-spinner" className="mobile-btn-pay" disabled />
                                        :
                                            <button className="mobile-btn-pay" onClick={saveCreate} disabled={listQuoterTest.length === 0} >
                                                Generar cotización
                                                <i className="fa fa-chevron-right"></i>
                                            </button>
                                    }
                                </div>

                            )
                        }

                        {
                            //* OPTIONS AFTER GENERATING THE QUOTE
                        }

                        {
                            viewQuoter && (
                                
                                <div className="mobile-footer-sheet">

                                    <Button
                                        label={loadingSend ? "Enviando..." : "Enviar PDF"}
                                        icon={loadingSend ? "pi pi-spin pi-spinner" : "pi pi-envelope"}
                                        className="btn-send-quoter"
                                        onClick={sentPdf}
                                        disabled={loadingSend}
                                    />

                                    <Button
                                        label={loadingDownloadId === null ? "Descargar PDF" : "Descargando..."}
                                        icon={loadingDownloadId === null ? "pi pi-download" : "pi pi-spin pi-spinner"}
                                        className="btn-download-quoter"
                                        onClick={() => downdloadQuoter()}
                                        disabled={loadingDownloadId !== null ? true : false}
                                    />

                                    <Button
                                        label="Listado"
                                        icon="pi pi-list"
                                        className="btn-list-quoter"
                                        onClick={goToListQuoter}
                                    />

                                    <SplitButton
                                        label="Nueva cotización"
                                        icon="pi pi-plus"
                                        model={newQuotationItems}
                                        className="btn-new-quoter"
                                    />

                                </div>

                            )
                        }

                        </div>

                    </footer>

                )
            }

            

        </>
    )
}
